<template>
  <div class="add-update-container">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item :label="$t('chongzhiguize.rechargeName')" prop="chongzhiname">
        <el-input v-model="dataForm.chongzhiname" :placeholder="$t('chongzhiguize.rechargeName')" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('chongzhiguize.minAmount')" prop="minamount">
        <el-input-number v-model="dataForm.minamount" :min="0" :max="99999999" :precision="2" :step="10" :placeholder="$t('chongzhiguize.minAmount')"></el-input-number>
        <span class="unit">{{ $t('chongzhiguize.yuan') }}</span>
      </el-form-item>
      <el-form-item :label="$t('chongzhiguize.bonus')" prop="bonus">
        <el-input-number v-model="dataForm.bonus" :min="0" :max="99999999" :precision="2" :step="10" :placeholder="$t('chongzhiguize.bonus')"></el-input-number>
        <span class="unit">{{ $t('chongzhiguize.yuan') }}</span>
      </el-form-item>
      <el-form-item :label="$t('chongzhiguize.discount')" prop="discount">
        <el-input-number v-model="dataForm.discount" :min="0" :max="1" :precision="2" :step="0.1" :placeholder="$t('chongzhiguize.discount')"></el-input-number>
        <span class="unit">{{ $t('chongzhiguize.discountDescription') }}</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm()">{{ !dataForm.id ? $t('chongzhiguize.confirmAdd') : $t('chongzhiguize.confirmEdit') }}</el-button>
        <el-button @click="cancel()">{{ $t('chongzhiguize.cancel') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    parent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dataForm: {
        id: 0,
        chongzhiname: '',
        minamount: 10.00,
        bonus: 0.00,
        discount: 1.0,
        chuangjiantime: null,
        gengxintime: null
      },
      dataRule: {
        chongzhiname: [
          { required: true, message: '请输入充值名称', trigger: 'blur' }
        ],
        minamount: [
          { required: true, message: '请输入最低充值金额', trigger: 'blur' }
        ],
        bonus: [
          { required: true, message: '请输入赠送金额', trigger: 'blur' }
        ],
        discount: [
          { required: true, message: '请输入折扣', trigger: 'blur' }
        ]
      },
      type: ''
    }
  },
  methods: {
    init(id, type) {
      this.dataForm.id = id || 0;
      this.type = type || '';
      if (this.dataForm.id) {
        this.$http({
          url: `chongzhiguize/info/${this.dataForm.id}`,
          method: 'get'
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.dataForm = data.data;
          }
        });
      }
    },
    // 表单提交
    submitForm() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `chongzhiguize/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            data: JSON.parse(JSON.stringify(this.dataForm))
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.parent.showFlag = true;
                  this.parent.addOrUpdateFlag = false;
                  this.parent.getDataList();
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    // 取消
    cancel() {
      if (this.parent) {
        this.parent.showFlag = true;
        this.parent.addOrUpdateFlag = false;
      } else {
        console.error("Parent component not found");
      }
    }
  }
}
</script>

<style scoped>
.add-update-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.unit {
  margin-left: 10px;
  color: #999;
  font-size: 14px;
}
</style> 